import script from "./SoundComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./SoundComponent.vue?vue&type=script&setup=true&lang=js"

import "./SoundComponent.vue?vue&type=style&index=0&id=7b0ed760&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7b0ed760"]])

export default __exports__